<template>
    <admin-layout :show-sidebar="false" mainPage="project">

        <template v-if="editable" #toolbox>
            <learning-path-toolbox :learning-path="path_repo" />
        </template>

        <app-content-pane class="ml-3" v-if="path_repo">
            <template #title>

                <heading :project="project" :path="path" :actions="head_actions" :tenants="tenants" @action="headAction"
                    page="path" class="mb-3" />
            </template>
            <section>

                <div class="header">
                    <h5 class="title">Project Details</h5>
                </div>

                <div class="details-row">
                    <div class="details-col details-col-small">
                        <label for="project-name" class="col-form-label">Project Name</label>
                    </div>
                    <div class="details-col details-col-large">
                        <input type="text" id="project-name" class="form-control form-control-lg" v-model="project.name"
                            @change="updateSettings" aria-describedby="project-name">
                    </div>
                </div>

                <div class="details-row">
                    <div class="details-col details-col-small">
                        <label for="project-name" class="col-form-label">Classroom</label>
                    </div>
                    <div class="details-col details-col-large">
                        <input type="text" id="project-classroom" class="form-control form-control-lg" v-model="project.classroom"
                               @change="updateSettings" aria-describedby="project-classroom">
                    </div>
                </div>

                <hr class="mt-0">

                <div class="details-row">
                    <div class="details-col details-col-small">
                        <label for="project-theme" class="col-form-label">Goal</label>
                    </div>
                    <div class="details-col details-col-large">
                        <select id="project-theme" class="form-control" v-model="project.theme" @change="updateSettings"
                            aria-describedby="project-theme">
                            <option :value="theme.id" v-for="theme in themes">{{ theme.name }}</option>
                        </select>
                    </div>
                </div>

                <div class="details-row">
                    <div class="details-col details-col-small">
                        <label for="project-learning-path" class="col-form-label">Source Learning Path</label>
                    </div>
                    <div class="details-col details-col-med">
                        <select id="project-learning-path" class="form-control" v-model="project.learning_path.parent_id"
                            disabled aria-describedby="project-learning-path">
                            <option v-for="path in learning_paths" :value="path.id">{{ path.name }}</option>
                        </select>

                    </div>
                    <div class="details-col details-col-small">
                        <button type="button" class="btn btn-danger btn-block" disabled>Customize</button>
                    </div>
                </div>

                <div class="details-row">
                    <div class="details-col details-col-small"></div>
                    <div class="details-col details-col-large">
                        <p class="text-danger mb-0">
                            Warning: Switching or Customizing learning path is a destructive
                            process and will remove any existing project & canvas data that
                            are not in common.
                        </p>
                    </div>
                </div>

                <div class="details-row" v-if="is_admin">
                    <div class="details-col details-col-small">
                        <label for="project-editable-by" class="col-form-label">Editable By</label>
                    </div>
                    <div class="details-col details-col-large">
                        <select class="form-control"
                                id="project-editable-by"
                                v-model="meta.editable_by"
                                @change="updateSettings"
                        >
                            <option value="admin">Admin</option>
                            <option value="teacher">Teacher</option>
                        </select>
                    </div>
                </div>

                <div class="details-row">
                    <div class="details-col details-col-small">
                        <label for="project-unlock-mission" class="col-form-label">Unlock Stage Mission</label>
                    </div>
                    <div class="details-col details-col-large">
                        <select id="project-unlock-mission" class="form-control" v-model="meta.unlock_mission"
                            @change="updateSettings" aria-describedby="project-unlock-mission">
                            <option v-for="(option, option_id) in unlock_mission_options" :key="option_id"
                                :value="option_id">
                                {{ option }}
                            </option>
                        </select>

                    </div>
                </div>

                <div class="details-row">
                    <div class="details-col details-col-small">
                        <label for="project-unlock-stage" class="col-form-label">Unlock Next Stage</label>
                    </div>
                    <div class="details-col details-col-large">
                        <select id="project-unlock-stage" class="form-control" v-model="meta.unlock_stage"
                            @change="updateSettings" aria-describedby="project-unlock-stage">
                            <option v-for="(option, option_id) in unlock_stage_options" :key="option_id" :value="option_id">
                                {{ option }}
                            </option>
                        </select>

                    </div>
                </div>

                <div class="button-holder">
                    <state-button v-if="showDelete" type="button" class="btn btn-danger" :disabled="is_deleting"
                        :state="is_deleting ? 'busy' : ''" @click.prevent.stop="remove(project)">
                        Delete
                    </state-button>
                    <state-button v-if="showClone" :state="is_cloning ? 'busy' : ''" :disabled="is_cloning"
                        :spinner-dark="true" class="btn btn-outline-dark" @click.prevent.stop="cloneProject()">Clone
                        Project</state-button>
                </div>
            </section>
        </app-content-pane>

    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import unlock_mission_options from '@/DATA/unlock_mission_options';
import unlock_stage_options from '@/DATA/unlock_stage_options';
import { mapActions } from "vuex";
import API from "@/API";
import Heading from "@/Components/Project/Heading";
import stages from "@/DATA/stages";
import themes from "@/DATA/themes";
import StateButton from "@/Components/Common/StateButton";

export default {
    name: "Details",
    components: {
        AdminLayout,
        AppContentPane,
        Heading,
        StateButton
    },

    props: {
        path: {
            type: [Object],
            default: () => null,
        },
        project: {
            type: Object,
            default: () => null,
        },
        showDelete: {
            type: Boolean,
            default: false
        },
        showClone: {
            type: Boolean,
            default: false
        },
        tenants: {
            type: Array,
            default: () => [],
        }
    },

    data() {
        return {

            path_repo: null,
            scope: { name: API.fragments.SCOPE_LEARNING_PATH, id: this.path.id },
            projects: [], /*projects.filter(p => p.learning_path.id == this.path )*/

            head_actions: {},

            // settings: null,

            okay: false,


            is_deleting: false,
            is_cloning: false,
            learning_paths: [],
            themes,
            unlock_mission_options,
            unlock_stage_options,
            available_stages: stages,

        };
    },


    computed: {
        meta: {
            get() {
                const meta = Array.isArray(this.project.meta) ? {} : this.project.meta;
                return meta ? meta : {};
            },
            set(meta) {
                this.project.meta = meta;
            }
        },
        show_sidebar() {
            return this.$page.props.user.is_admin || this.$page.props.user?.project_count > 0;
        },

        editable() {
            // return (this.$page.props.user.is_admin || ( this.$page.props.user.is_teacher && this.path.created_by_id === this.$page.props.user.id));
            // return this.has_edit_access && this.head_actions?.edit?.active;
            return this.has_edit_access;
        }
    },


    methods: {
        ...mapActions('repositories', {
            repo: 'getRepository',
            freeRepo: 'freeRepository',
            updateRepo: 'updateRepository',
        }),

        headAction(method, action) {
            switch (method) {

                case 'edit':

                    action.active = !action.active;

                    if (action.active) {
                        action.class = 'btn-feel';
                        action.title = 'Finish Editing';
                    } else {
                        action.class = 'btn-outline-feel';
                        action.title = 'Advanced Editing';
                    }

                    break;
                //
                //
                // case 'settings':
                //     this.openSettings();
                //
                //     break;

            }
        },

        // openSettings(){
        //     this.settings = this.path;
        // },
        //
        // closeSettings(){
        //     this.settings = null;
        // },
        //
        // pathDeleted(path){
        //     this.$inertia.visit( route('project.dashboard', {...this.global_url_params}) );
        //     this.closeSettings();
        // },

        missionChanged({ stage, missions }) {
            const fragments = {};
            fragments[`stage_${stage}_mission_questions`] = missions;
            this.updateRepo({ scope: this.scope, fragments });
        },

        resourceChanged({ stage, resources }) {
            const fragments = {};
            fragments[`stage_${stage}_resources`] = resources;
            this.updateRepo({ scope: this.scope, fragments });
        },

        activityGroupChanged({ stage, sections }) {
            const fragments = {};
            fragments[`stage_${stage}_activity_sections`] = sections;
            this.updateRepo({ scope: this.scope, fragments });
        },

        activitiesChanged({ stage, section, activities }) {
            console.log('Activities Changed.', { stage, section, activities });
            const fragments = {};
            fragments[`stage_${stage}_activities_${section.id}`] = activities;
            this.updateRepo({ scope: this.scope, fragments });
        },

        combinedActivitiesChanged({ stage, section, activities }) {
            const fragments = {};
            console.log({ stage, section, activities });
            fragments[`stage_${stage}_combined_activities_${section.id}`] = activities;
            this.updateRepo({ scope: this.scope, fragments });
        },

        async updateSettings(){
            const project = await API.projects.updateSettings(this.project.id, {
                name: this.project.name,
                classroom: this.project.classroom,
                theme: this.project.theme,
                meta: this.meta,
            });

            this.project.name = project.name;
            this.project.classroom = project.classroom;
            this.project.theme = project.theme;
            this.meta = project.meta;
        },

        remove(project) {
            const res = confirm('Are you sure to delete this project?\n\nThis will destroy all data associated to this project and can\'t be undone.')
            if (res) {
                this.$inertia.delete(this.route('project.destroy', { project: project.id, ...this.global_url_params }), {
                    onStart: () => this.is_deleting = true,
                    onSuccess: () => console.log("Successfully Deleted!"),
                    onError: (errors) => console.log("Errors:", errors),
                    onFinish: () => {
                        this.is_deleting = false;
                        // this.$inertia.visit(this.route('project.index', { ...this.global_url_params }))
                        window.location.href="/app/project"
                    },
                });
            }
        },

        cloned(project){
            // this.$inertia.reload({only: ['projects']});
            this.$inertia.visit( this.route('project.details', {project: project.id, ...this.global_url_params}) );
        },

        async cloneProject() {


            this.is_cloning = true;
            try {
                const project = await API.projects.clone(this.project.id);
                // this.$emit('cloned', project);
                this.cloned(project)
            } catch (e) {
                console.log(e)
            }
            this.is_cloning = false;

        }

    },

    beforeMount() {

        if (this.has_edit_access) {

            // if( this.is_admin || true ){
            //     this.head_actions['edit'] = {
            //         class: 'btn-outline-feel',
            //         title: 'Advanced Editing',
            //         active: false,
            //     };
            // }
        }
    },

    async mounted() {

        if (this.path) {
            this.path_repo = (await this.repo(this.scope));
        }
        this.learning_paths = await API.learning_paths.bulk();
        // TODO: Get projects of this learning path if 'project' property is not set.



        if (this.project) {
            this.setTitle(`${this.project.name} - Project Details`);
        } else {
            this.setTitle(`${this.path.name}`);
        }

    }

}
</script>

<style lang="scss" scoped>
.actions {
    display: flex;
    align-items: center;

    background: $dark;
    color: $light;
}

.header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 1rem 1rem;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);

    .title {
        margin-bottom: 0;
        line-height: 1.6;
    }
}

.details-row {
    display: flex;
    margin-bottom: 10px;

    .details-col {
        padding: 0.5rem 1rem;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .details-col-small {
        width: 25%;
    }

    .details-col-large {
        width: 75%;
    }

    .details-col-med {
        width: 50%;
    }
}

.button-holder {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    padding: 1rem;
}
</style>
